function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* jshint esversion: 8 */
import { ConfigurationService } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
import { I18N } from "../Shared/I18n";
import { OAuthService } from "./OAuthService";
export var UserService = /*#__PURE__*/function () {
  function UserService() {
    _classCallCheck(this, UserService);
  }

  _createClass(UserService, null, [{
    key: "GetCurrentUser",
    value: function () {
      var _GetCurrentUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var i18n, userNotAuthenticatedMsg, userNotFoundMsg, appRoot, url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N("mpp-user-service");

              case 2:
                i18n = _context.sent;
                userNotAuthenticatedMsg = i18n.notAuthenticatedMessage;
                userNotFoundMsg = i18n.userNotFound; // Get configuration

                appRoot = ConfigurationService.GetAppRoot();
                url = "".concat(appRoot, "/Api/Auth/User"); // Get current user with setTimeout to push it to the end of the event queue

                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    Ajax.Get(url).then(function (userInfo) {
                      if (!!userInfo) {
                        resolve(userInfo);
                      } else {
                        reject(userNotFoundMsg);
                      }
                    }, function (error) {
                      console.error(userNotAuthenticatedMsg);
                      reject(userNotFoundMsg);
                    });
                  }, 0);
                }));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetCurrentUser() {
        return _GetCurrentUser.apply(this, arguments);
      }

      return GetCurrentUser;
    }()
  }, {
    key: "GetCurrentUserAttributes",
    value: function () {
      var _GetCurrentUserAttributes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var appRoot, url, currentUserAttributes;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Get configuration
                appRoot = ConfigurationService.GetAppRoot();
                url = "".concat(appRoot, "/Api/Attributes/ContactAttributes"); // Get current user attributes

                currentUserAttributes = new Promise(function (resolve, reject) {
                  Ajax.Get(url).then(function (userAttributesInfo) {
                    if (!!userAttributesInfo) {
                      resolve(userAttributesInfo);
                    } else {
                      reject(0);
                    }
                  }, function () {
                    reject(0);
                  });
                }); // Return currentUser

                _context2.next = 5;
                return currentUserAttributes;

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetCurrentUserAttributes() {
        return _GetCurrentUserAttributes.apply(this, arguments);
      }

      return GetCurrentUserAttributes;
    }()
  }, {
    key: "GetAllActiveAttributes",
    value: function () {
      var _GetAllActiveAttributes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var appRoot, url, allActiveAttributes;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Get configuration
                appRoot = ConfigurationService.GetAppRoot();
                url = "".concat(appRoot, "/Api/Attributes/Available");
                allActiveAttributes = new Promise(function (resolve, reject) {
                  Ajax.Get(url).then(function (allAttributesInfo) {
                    if (!!allAttributesInfo) {
                      resolve(allAttributesInfo);
                    } else {
                      reject(0);
                    }
                  }, function () {
                    reject(0);
                  });
                }); // Return all attributes

                _context3.next = 5;
                return allActiveAttributes;

              case 5:
                return _context3.abrupt("return", _context3.sent);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetAllActiveAttributes() {
        return _GetAllActiveAttributes.apply(this, arguments);
      }

      return GetAllActiveAttributes;
    }()
  }, {
    key: "SaveUserAttributes",
    value: function () {
      var _SaveUserAttributes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
        var appRoot, url, allActiveAttributes;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Get configuration
                appRoot = ConfigurationService.GetAppRoot();
                url = "".concat(appRoot, "/Api/Attributes");
                allActiveAttributes = new Promise(function (resolve, reject) {
                  Ajax.Post(url, data, {
                    'Content-Type': "application/json"
                  }).then(function () {
                    resolve(1);
                  }, function (err) {
                    reject(err);
                  });
                }); // Return all attributes

                _context4.next = 5;
                return allActiveAttributes;

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function SaveUserAttributes(_x) {
        return _SaveUserAttributes.apply(this, arguments);
      }

      return SaveUserAttributes;
    }()
  }]);

  return UserService;
}();